import React, { Component } from "react";
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
const numberWithCommas_display = require('../service/excelService.js').numberWithCommas_display;
const changeFloat = require('../service/excelService.js').changeFloat;



class ExportPDF extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataSet: [],
            type: '',

            documentDefinition: {
                pageSize: 'A4',
                pageOrientation: 'portrait',
                content: [],
                dontBreakRows: true,
                pageMargins: [30, 50, 30, 50],
                startPosition: {
                    horizontalRatio: 0.2
                }
            }

        }

    }

    componentDidMount() {
        this.setState({ dataSet: this.props.data }, () => {
            this._exportPdfTable();
        });
    }

    componentWillUnmount() {
        this._exportPdfTable();
    }

    renderDesigRows(desigs) {
        var desigRows = []

        for (var i = 0; i < desigs.length; i++) {

            var desig = desigs[i];
            var row = []
            row.push({ text: desig['DesigID'], alignment: "left" })
            row.push({ text: desig['DesigName'], alignment: "left" })
            row.push({ text: desig['Count'], alignment: "right" })

            if (desig['TenderedAmount']) {
                row.push({ text: '$' + numberWithCommas_display(desig['TenderedAmount']), alignment: "right" })
            }
            else {
                row.push('');
            }

            if (desig['SinAdmin']) {
                row.push({ text: '$' + numberWithCommas_display(desig['SinAdmin']), alignment: "right" })
            }
            else {
                row.push('');
            }

            if (desig['Net']) {
                row.push({ text: '$' + numberWithCommas_display(desig['Net']), alignment: "right" })
            }
            else {
                row.push('');
            }

            desigRows.push(row)

        }

        return desigRows;

    }

    renderColRow(columns) {

        var row = []

        for (var j = 0; j < columns.length - 1; j++) {

            var col = columns[j].name;
            row.push({ text: col, alignment: "left" })

        }

        return row;
    }

    renderTotalRow(group) {

        var row = ['', ''];
        row.push({ text: 'Total:', alignment: "right", bold: true })

        if (group.donation_total) {
            row.push({ text: '$' + numberWithCommas_display(group.donation_total), alignment: "right", bold: true })
        }
        else {
            row.push('');
        }

        if (group.sinadmin_total) {
            row.push({ text: '$' + numberWithCommas_display(group.sinadmin_total), alignment: "right", bold: true })
        }
        else {
            row.push('');
        }

        if (group.net_total) {
            row.push({ text: '$' + numberWithCommas_display(group.net_total), alignment: "right", bold: true })
        }
        else {
            row.push('');
        }

        return row

    }

    formGrandTotalRow(donation_grand_total, sinadmin_grand_total, net_grand_total) {

        return (['', '',
            { text: 'Grand Total:', alignment: "right", bold: true },
            { text: '$' + numberWithCommas_display(donation_grand_total), alignment: "right", bold: true },
            { text: '$' + numberWithCommas_display(sinadmin_grand_total), alignment: "right", bold: true },
            { text: '$' + numberWithCommas_display(net_grand_total), alignment: "right", bold: true }

        ])

    }


    renderGroups(columns, groupList) {

        var rows = []
        var columnRow = this.renderColRow(columns);
        rows.push(columnRow);

        var donation_grand_total = 0;
        var sinadmin_grand_total = 0;
        var net_grand_total = 0;

        if (groupList && groupList.length && columns) {

            for (var i = 0; i < groupList.length; i++) { // last col 'change group' no need
                var group = groupList[i];

                var groupName = group.group;
                var desigs = group.desigs;

                if (desigs) { // If this group has donations

                    var groupNameRow = [
                        { text: 'Donation Group: ', alignment: "left", bold: true },
                        { text: groupName, alignment: "left", bold: true },
                        '', '', '', ''
                    ]
                    rows.push(groupNameRow);

                    var desigrows = this.renderDesigRows(desigs);
                    rows = rows.concat(desigrows);

                    var totalRow = this.renderTotalRow(group);
                    rows.push(totalRow);

                    donation_grand_total = donation_grand_total + changeFloat(group.donation_total);
                    sinadmin_grand_total = sinadmin_grand_total + changeFloat(group.sinadmin_total);
                    net_grand_total = net_grand_total + changeFloat(group.net_total);

                }

            }

            var grandTotalRow = this.formGrandTotalRow(donation_grand_total, sinadmin_grand_total, net_grand_total)
            rows.push(grandTotalRow);


            return rows

        }

        return rows

    }


    _exportPdfTable = () => {
        const { dataSet } = this.state;
        // console.log('sorted donations report PDF',dataSet);

        const title = {
            text: dataSet.title,
            alignment: 'center',
            bold: true, fontSize: 16
        }

        const groupList = dataSet.data;
        const columns = dataSet.columns;

        var body = this.renderGroups(columns, groupList);

        var income = {
            table: {
                //   widths:widths,
                //   heights:heights,
                headerRows: 1,
                //   dontBreakRows: true,
                body: body
            },
            layout: 'headerLineOnly'
        }

        var content = [title, income];

        // console.log('content', content)

        this.setState({ documentDefinition: { ...this.state.documentDefinition, content: content } });

    }

    onClick = () => {
        var documentDefinition = this.state.documentDefinition;
        const { vfs } = vfsFonts.pdfMake;
        pdfMake.vfs = vfs;
        return pdfMake.createPdf(documentDefinition).open();
    }

    render() {
        return (<button type="button" className='btn btn-primary' onClick={this.onClick.bind()}>Download PDF</button>)
    }


}


export default ExportPDF;
